/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Key_HighlightsInputs */

const en_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Highlights`)
};

const es_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos clave`)
};

const fr_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points forts`)
};

const de_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtige Highlights`)
};

const ja_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主な特徴`)
};

const zh_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心亮点`)
};

const ar_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أبرز المزايا`)
};

const id_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorotan Utama`)
};

const it_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti Chiave`)
};

const ru_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключевые особенности`)
};

const pt_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais Destaques`)
};

const ko_key_highlights = /** @type {(inputs: Key_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 특징`)
};

/**
* | output |
* | --- |
* | "Key Highlights" |
*
* @param {Key_HighlightsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const key_highlights = /** @type {((inputs?: Key_HighlightsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Key_HighlightsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_key_highlights(inputs)
	if (locale === "es") return es_key_highlights(inputs)
	if (locale === "fr") return fr_key_highlights(inputs)
	if (locale === "de") return de_key_highlights(inputs)
	if (locale === "ja") return ja_key_highlights(inputs)
	if (locale === "zh") return zh_key_highlights(inputs)
	if (locale === "ar") return ar_key_highlights(inputs)
	if (locale === "id") return id_key_highlights(inputs)
	if (locale === "it") return it_key_highlights(inputs)
	if (locale === "ru") return ru_key_highlights(inputs)
	if (locale === "pt") return pt_key_highlights(inputs)
	return ko_key_highlights(inputs)
});